<template>
  <div v-if="!isAdminRoute" class="tutorial-host">
    <LoadingOverlay v-if="journeyLoading" />
    <TutorialWelcome v-if="welcomeOpen" />
    <TutorialChecklistPanel v-if="checklistOpen" />
    <TutorialCoachmark v-if="activeCoachmark" />
    <TutorialPageHighlights v-if="pageTourActive" />
    <TutorialPageTourInvitation v-else-if="pageTourInvite" />
    <TutorialContinueExploring />
  </div>
</template>

<script>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useTutorialProgress } from '@/composables/useTutorialProgress';
import LoadingOverlay from '@/components/LoadingOverlay.vue';
import TutorialWelcome from './TutorialWelcome.vue';
import TutorialChecklistPanel from './TutorialChecklistPanel.vue';
import TutorialCoachmark from './TutorialCoachmark.vue';
import TutorialContinueExploring from './TutorialContinueExploring.vue';
import TutorialPageTourInvitation from './TutorialPageTourInvitation.vue';
import TutorialPageHighlights from './TutorialPageHighlights.vue';

export default {
  name: 'TutorialHost',
  components: {
    LoadingOverlay,
    TutorialWelcome,
    TutorialChecklistPanel,
    TutorialCoachmark,
    TutorialContinueExploring,
    TutorialPageTourInvitation,
    TutorialPageHighlights,
  },
  setup() {
    const tutorial = useTutorialProgress();
    const route = useRoute();
    return {
      isAdminRoute: computed(() => (route.path || '').startsWith('/admin')),
      welcomeOpen: computed(() => tutorial.state.welcomeOpen),
      checklistOpen: computed(() => tutorial.state.checklistOpen),
      activeCoachmark: computed(() => tutorial.state.activeCoachmarkId),
      journeyLoading: computed(() => tutorial.state.journeyLoading),
      pageTourActive: computed(() => !!tutorial.state.activePageTourId),
      pageTourInvite: computed(() => !!tutorial.state.pageTourInvitationVisible),
    };
  },
  watch: {
    '$route.fullPath': {
      immediate: true,
      handler(path) {
        const p = typeof path === 'string' ? path : this.$route.path;
        if ((p || '').startsWith('/admin')) return;
        const tutorial = useTutorialProgress();
        tutorial.onRouteEntered(p);
      },
    },
  },
};
</script>
